export default {
 pageTitle: 'Offshore Company Registration',
 heroDesc: 'Offshore registration services in leading global jurisdictions, professional team assistance throughout',
 heroTag1: '50+ countries and regions',
 heroTag2: 'One-stop service',
 heroTag3: 'Professional and reliable',
 countriesTitle: 'Popular Registration Jurisdictions',
 countriesSubtitle: 'Choose the jurisdiction that best suits your business',
 popular: 'Popular',
 country1Name: 'HK Company Registration',
 country1Feature1: 'Registration completed in 1 day',
 country1Feature2: 'Tax rate as low as 16.5%',
 country1Feature3: 'No foreign exchange controls',
 country1Feature4: 'International financial center',
 country2Name: 'US Company Registration',
 country2Feature1: 'Largest global market',
 country2Feature2: 'High brand value',
 country2Feature3: 'Facilitates fundraising and listing',
 country2Feature4: 'Flexible state selection',
 country3Name: 'Singapore Company Registration',
 country3Feature1: 'Asian financial hub',
 country3Feature2: 'Tax incentives',
 country3Feature3: 'Strong government support',
 country3Feature4: 'Strategic location',
 country4Name: 'BVI Company Registration',
 country4Feature1: 'High confidentiality',
 country4Feature2: 'No corporate income tax',
 country4Feature3: 'Flexible equity structure',
 country4Feature4: 'Low maintenance cost',
 country5Name: 'Cayman Islands Company Registration',
 country5Feature1: 'Preferred for listing structures',
 country5Feature2: 'Zero tax rate advantage',
 country5Feature3: 'High international recognition',
 country5Feature4: 'Robust legal system',
 country6Name: 'UK Company Registration',
 country6Feature1: 'Gateway to European markets',
 country6Feature2: 'Strong brand effect',
 country6Feature3: 'Fast registration process',
 country6Feature4: 'Comprehensive legal protection',
 advantagesTitle: 'Advantages of Offshore Companies',
 advantagesSubtitle: 'Why choose offshore companies?',
 advantage1Title: 'Global Business Expansion',
 advantage1Desc: 'Utilize offshore companies to facilitate international trade and investment activities',
 advantage2Title: 'Asset Protection',
 advantage2Desc: 'Reasonable asset allocation planning to effectively protect corporate and personal assets',
 advantage3Title: 'Tax Optimization',
 advantage3Desc: 'Legally utilize tax incentives to reduce corporate operating costs',
 advantage4Title: 'Listing Structure',
 advantage4Desc: 'Build standard red chip or VIE structures to prepare for future listings',
 processTitle: 'Registration Process',
 process1: 'Consultation and determination of jurisdiction and plan',
 process2: 'Preparation of relevant documents and files',
 process3: 'Company name search and confirmation',
 process4: 'Submission of registration application',
 process5: 'Obtaining company registration certificate',
 process6: 'Subsequent support services (account opening, tax, etc.)',
 ctaTitle: 'Embark on Your Global Journey',
 ctaDesc: 'Our professional team will provide you with the optimal offshore company registration plan',
 ctaButton: 'Free Consultation',
}
